import { useMemo } from "react";
import { useAuth } from "../contexts/AuthContext";

export const HIDDEN_ROLES = Object.freeze({
  DEPLOYMENT: "Hide-Deployment",
  API_KEY: "Hide_API_KEY",
});

export const DEPLOYMENTS_HIDDEN_HOSTNAMES = Object.freeze([]);

export const canViewDeploymentsForRoles = (roles) =>
  !roles?.includes(HIDDEN_ROLES.DEPLOYMENT);

export const canViewApiKeyForRoles = (roles) =>
  !roles?.includes(HIDDEN_ROLES.API_KEY);

export const getIsInferenceOnly = (inferenceOnly) => {
  if (!Boolean(localStorage.getItem("currentOrganizationId"))) {
    return Boolean(inferenceOnly);
  }

  return localStorage.getItem("currentOrganizationIsInferenceOnly") === "true";
};
export const canViewDeploymentsForHostname = (hostname) =>
  !DEPLOYMENTS_HIDDEN_HOSTNAMES.includes(hostname?.toLowerCase());

export const usePermissions = () => {
  const { userProfile, inferenceOnly } = useAuth();
  const roles = userProfile?.roles;
  const hostname =
    typeof window === "undefined" ? undefined : window.location.hostname;

  return useMemo(
    () => ({
      canViewDeployments:
        canViewDeploymentsForRoles(roles) &&
        canViewDeploymentsForHostname(hostname),
      canViewApiKey: canViewApiKeyForRoles(roles),
      isInferenceOnly: getIsInferenceOnly(inferenceOnly),
    }),
    [hostname, roles, inferenceOnly],
  );
};
